'use strict';
const RequestManager = require('../helpers/request-manager');
const ParamsManager = require('../helpers/params-manager');
const errorHandler = require('../helpers/error-handler');

class Offers {
  constructor(credentials, request, sdkConfiguration) {
    this.requestManager = new RequestManager(sdkConfiguration, request, credentials);
    this.paramsManager = new ParamsManager();
  }

  byCountryCode(country) {
    this.country = country;
    return this;
  }

  byId(offerId) {
    this.offerId = offerId;
    return this;
  }

  get(locale) {
    this.validateContryCode();
    if (this.offerId) {
      this.requestManager.requestConfigurationManager.setApi('GetOffer');
      this.paramsManager.addPathParam(this.offerId);
    } else {
      this.requestManager.requestConfigurationManager.setApi('GetOffers');
    }
    if (locale) { 
      this.paramsManager.addHeaderParams('X-Locale', locale);
    }
    this.paramsManager.addQueryParam({ country: this.country });
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  getCategories() {
    this.validateContryCode();
    this.requestManager.requestConfigurationManager.setApi('GetOfferCategories');
    this.paramsManager.addQueryParam({ country: this.country });
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  getAddons() {
    this.validateContryCode();
    this.validateOfferId();
    this.requestManager.requestConfigurationManager.setApi('GetOfferAddOns');
    this.paramsManager.addPathParam(this.offerId);
    this.paramsManager.addQueryParam({ country: this.country });
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  validateContryCode() {
    if (!this.country) {
      throw errorHandler.handleError('To use this function, first use the byCountryCode function, to set the country');
    }
  }

  validateOfferId() {
    if (!this.offerId) {
      throw errorHandler.handleError('To use this function, first use the byId function, to set the offerId');
    }
  }

}

module.exports = Offers;
